import path from "path"

export function extractFileName (fileName: String)
{ 
    return fileName.substring(fileName.lastIndexOf(path.sep)+1) 
}